<script lang="ts" setup>
import { computed, onMounted, onUnmounted } from 'vue'

import { useMicLevelLiveKit } from '@hooks/classroom/mic-level-live-kit.hook'

defineOptions({
  name: 'LessonRoomMicLevel',
})

const { level, start, stop } = useMicLevelLiveKit()

// level is 0..1; clamp defensively for the width style.
const fillWidth = computed<string>(() => `${Math.min(1, Math.max(0, level.value)) * 100}%`)

onMounted(start)
onUnmounted(stop)
</script>

<template>
  <div class="lesson-room-mic-level">
    <span
      class="lesson-room-mic-level__fill"
      :style="{ width: fillWidth }"
    />
  </div>
</template>

<style scoped lang="scss" src="@scss/components/Molecules/LessonRoom/LessonRoomMicLevel.scss" />
